export default __webpack_public_path__ + "static/media/cert-finance-cpttm.66221491.jpg";